module.exports = __webpack_public_path__ + "img/form.25b762f8.png";